import React, {useCallback} from "react";
import { createRoot } from 'react-dom/client'
import '/src/i18n';
import HookOfferItems from './Offers/HookOfferItems';

const renderComponent = (id, Component) => {
	const rootElement = document.getElementById(id);
  	if (rootElement) {
    	const root = createRoot(rootElement);
    	root.render(<Component {...rootElement.dataset} />);
  	}
};

renderComponent("hook-offer-items", HookOfferItems);